<template>
  <div class="box-tools">
    <slot name="hide">
      <button type="button" class="btn btn-box-tool" data-widget="collapse">
        <i class="fa fa-minus"></i>
      </button>
    </slot>
  </div>
</template>